<template>
    <list-export-payment
            :chargeId="44"
            ref="childref"
    >
        <template v-slot:select>
            <v-btn
                    large
                    class="mr-12"
                    @click="save()"
            >
                Выбрать
            </v-btn>
        </template>
        <template v-slot:cancel>
            <v-btn
                    large
                    class="mr-12"
                    @click="close()"
            >
                Отмена
            </v-btn>
        </template>
    </list-export-payment>
</template>

<script>
import ListExportPayment from '../base/listExportPaymentBase'

export default {
  name: 'test',
  props: {
    id: Number
  },
  // mixins: [myMixin],
  components: { ListExportPayment },
  data () {
    return {
      t: 1
    }
  },
  methods: {
    close () {
      // this.$store.commit('gis_gmpCharge/setTab', 'tab-4')
      this.$store.commit('gis_gmpExportPayment/setSearch', '')
      this.$store.commit('gis_gmpExportPayment/setSelected', [])
      this.$router.go(-1)
    },
    save () {
      let ides = this.$refs.childref.selected.map(function (item) {
        return item.paymentId
      })
      if (ides.length > 0) {
        this.$store.commit(
          'gis_gmpForcedAcknowledgement/setCardPaymentId',
          ides[0]
        )
        this.close()
      }
    }
  }
}
</script>

<style scoped>

</style>
